import { useTranslation } from "react-i18next";
import LegalLayout from "../components/LegalLayout";

export default function Terms() {
  const { t } = useTranslation();
  const sections = t("terms.sections", { returnObjects: true }) as { title: string; body: string }[];
  const updated = t("terms.updated");

  return (
    <LegalLayout
      eyebrow={t("terms.eyebrow")}
      title={t("terms.title")}
      subtitle={t("terms.subtitle")}
      updated={updated}
      sections={sections}
    />
  );
}
